import { SessionStorage } from 'libs/storage/SessionStorage';
function storageKey(host) {
    return `store-promo-code.${host}`;
}
/**
 * Keeps the code of a `?promo=CODE` link for the tab session, so that it is
 * sent when the cart is created. A newer link replaces the previous code.
 */
export function captureStorePromoCode(host) {
    const code = new URLSearchParams(window.location.search).get('promo');
    if (code && code.trim()) {
        SessionStorage.set(storageKey(host), code.trim());
    }
}
export function loadStorePromoCode(host) {
    const stored = SessionStorage.get(storageKey(host));
    return typeof stored === 'string' && stored ? stored : undefined;
}
export function clearStorePromoCode(host) {
    SessionStorage.set(storageKey(host), null);
}
/**
 * Reason of a `PROMO_CODE_INVALID` error (GraphQL error or REST 409).
 */
export function promoCodeErrorReason(error) {
    var _a, _b, _c, _d;
    const graphQLErrors = error === null || error === void 0 ? void 0 : error.graphQLErrors;
    const promoError = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.find((entry) => (entry === null || entry === void 0 ? void 0 : entry.message) === 'PROMO_CODE_INVALID');
    if (promoError) {
        return ((_c = (_b = (_a = promoError.extensions) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.promoCode) !== null && _c !== void 0 ? _c : 'NOT_FOUND');
    }
    const rest = error;
    if ((rest === null || rest === void 0 ? void 0 : rest.error) === 'PROMO_CODE_INVALID') {
        return ((_d = rest.reason) !== null && _d !== void 0 ? _d : 'NOT_FOUND');
    }
    return null;
}
/**
 * Message shown to the customer for a promo code reason.
 */
export function promoCodeReasonMessage(reason) {
    switch (reason) {
        case 'NOT_FOUND':
        case 'INACTIVE':
            return t('This promo code is invalid.');
        case 'NOT_STARTED':
            return t('This promo code is not valid yet.');
        case 'EXPIRED':
            return t('This promo code has expired.');
        case 'USAGE_LIMIT_REACHED':
            return t('This promo code is no longer available.');
        case 'ALREADY_USED':
            return t('You have already used this promo code.');
        case 'STORE_NOT_ELIGIBLE':
            return t('This promo code is not valid in this store.');
        case 'NO_ELIGIBLE_ITEMS':
            return t('This promo code does not apply to the products in your cart.');
        case 'TOTAL_TOO_LOW':
            return t('This promo code cannot be used on this order.');
        case 'CART_NOT_EDITABLE':
            return t('This order can no longer be changed.');
        default:
            return t('This promo code is invalid.');
    }
}
